// extracted by mini-css-extract-plugin
export default {"main":"Login_main__i6b+q","logo":"Login_logo__L7xkq"};